import { render, staticRenderFns } from "./UserBirthdayModal.vue?vue&type=template&id=5a660046&"
import script from "./UserBirthdayModal.vue?vue&type=script&lang=js&"
export * from "./UserBirthdayModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports